module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-sorority-49ca0e4d72b007f62addab69a9f5dddb.jpg";